module.exports = __webpack_public_path__ + "static/media/add.1a1c737e.svg";